import { ChangeEvent, ReactElement } from 'react'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material'
import useChatIfcUpload from '../hooks/useChatIfcUpload'
import { ChangeDecision } from './DecisionButtons'
import FileRequestDecision from './FileRequestDecision'

interface Props {
  message: string | null
  decision: ChangeDecision | undefined
  /** Uploaded (and converted), or declined. */
  onDecide: (uploaded: boolean) => void
}

/** The agent asks for the IFC file of the import: picked, uploaded and converted right here. */
const IfcFileRequestItem = ({ message, decision, onDecide }: Props): ReactElement => {
  const { mutate: upload, isLoading } = useChatIfcUpload(() => onDecide(true))

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    event.target.value = ''
    if (file) upload(file)
  }

  return (
    <Box
      sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 1 }}
      data-cy="ai-chat-file-request-ifc"
    >
      <Typography variant="body2">{message ?? 'Bitte wählen Sie die IFC-Datei aus.'}</Typography>
      {decision ? (
        <FileRequestDecision decision={decision} />
      ) : (
        <Stack direction="row" spacing={1} mt={1} justifyContent="flex-end" alignItems="center">
          {isLoading && (
            <>
              <CircularProgress size={16} />
              <Typography variant="caption">Wird hochgeladen &amp; konvertiert …</Typography>
            </>
          )}
          <Button
            size="small"
            color="inherit"
            disabled={isLoading}
            onClick={() => onDecide(false)}
            data-cy="ai-chat-file-request-skip"
          >
            Ohne Datei
          </Button>
          <Button
            size="small"
            variant="contained"
            component="label"
            disabled={isLoading}
            startIcon={<UploadFileIcon fontSize="small" />}
            data-cy="ai-chat-file-request-ifc-select"
          >
            Datei auswählen
            <input
              hidden
              type="file"
              accept=".ifc"
              onChange={handleFileChange}
              data-cy="ai-chat-file-request-ifc-input"
            />
          </Button>
        </Stack>
      )}
    </Box>
  )
}

export default IfcFileRequestItem
